import type { MscKeyConfig, StorageEnvelope } from '../types';
import { createEnvelope, parseEnvelope } from '../envelope';
import { STORAGE_TYPES } from '../types';

function getStorage(cfg: MscKeyConfig): Storage | null {
  if (typeof window === 'undefined') return null;
  if (cfg.storage === STORAGE_TYPES.LOCAL) return window.localStorage;
  if (cfg.storage === STORAGE_TYPES.SESSION) return window.sessionStorage;
  return null;
}

export function webStorageSet(cfg: MscKeyConfig, value: unknown, expireAtEpochMs: number): boolean {
  const storage = getStorage(cfg);
  if (!storage) return false;
  const envelope = createEnvelope(value, expireAtEpochMs);
  try {
    storage.setItem(cfg.key, JSON.stringify(envelope));
    return true;
  } catch {
    return false;
  }
}

export function webStorageRemove(cfg: MscKeyConfig): void {
  const storage = getStorage(cfg);
  if (!storage) return;
  try {
    storage.removeItem(cfg.key);
  } catch {
    console.log('error removing key from storage', cfg.key);
  }
}

export function webStorageReadEnvelope(cfg: MscKeyConfig): StorageEnvelope | null {
  const storage = getStorage(cfg);
  if (!storage) return null;
  try {
    const raw = storage.getItem(cfg.key);
    if (!raw) return null;
    return parseEnvelope(raw);
  } catch {
    return null;
  }
}

export function webStorageHasValue(cfg: MscKeyConfig): boolean {
  const storage = getStorage(cfg);
  if (!storage) return false;
  try {
    return storage.getItem(cfg.key) !== null;
  } catch {
    return false;
  }
}

export function webStorageReadEnvelopeWithFlag(cfg: MscKeyConfig): {
  exists: boolean;
  envelope: StorageEnvelope | null;
  raw: string | null;
} {
  const storage = getStorage(cfg);
  if (!storage) return { exists: false, envelope: null, raw: null };
  try {
    const raw = storage.getItem(cfg.key);
    if (raw === null) return { exists: false, envelope: null, raw: null };
    return { exists: true, envelope: parseEnvelope(raw), raw };
  } catch {
    return { exists: false, envelope: null, raw: null };
  }
}
